<nav class="breadcrumb">
  <ng-container *ngIf="breadcrumbs">

    <!--Sort by deep. We are using observables so we don't receive breadcrumb info in the same order that we request-->
    <ng-template ngFor let-breadcrumb [ngForOf]="breadcrumbs | sort:'deep'">
      <a mat-button color="primary"
         [routerLink]="[breadcrumb.url]">
        {{breadcrumb.label}}
      </a>
      <mat-icon color="primary">chevron_right</mat-icon>
    </ng-template>
    <a mat-button class="last-link" disabled>{{action}}</a>
  </ng-container>
</nav>


